import React, { FC, ReactElement, useState } from 'react'
import { useAtom } from 'jotai'
import { createUseStyles } from 'react-jss'
import { NavLink } from 'react-router-dom'
import { colors } from '../../../theme/palette'
import { useContainerStyles } from '../../../theme/layout'
import breakpoints from '../../../theme/breakpoints'
import { ImitatorNoAccessWarning } from '../../modules/Imitator/ImitatorNoAccessWarning'
import { profileAtom } from '../../../api/profile/profile'

export interface IComponent {
    title: string
    component: ReactElement
}

const useStyles = createUseStyles({
    container: {
        background: colors.green,
        width: '100%',
    },
    menu: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem 0',
        listStyle: 'none',
        flexWrap: 'wrap',
        margin: 0,
        [`@media (max-width: ${breakpoints.Desktop}px)`]: {},
    },
    item: {
        background: '#fff',
        flexGrow: 1,
        padding: '0rem',
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            '&': {
                padding: '1rem 0',
            },
            '&:first-child': {
                borderRadius: '4px 0 0 4px',
                padding: '1rem 0 1rem 1rem',
            },
            '&:last-child': {
                borderRadius: '0 4px 4px 0',
                padding: '1rem 1rem 1rem 0',
            },
        },
    },
    link: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        color: colors.black,
        fontSize: '1rem',
        padding: '0.75rem',
        borderRadius: '6px',
        transition: 'all .3s',
        '&:hover, &.active': {
            cursor: 'pointer',
            backgroundColor: colors.green,
            color: colors.white,
        },
    },
})

interface TabItemProps {
    to: string
    label: string
}

const TabItem: FC<TabItemProps> = ({ label, to }) => {
    const classes = useStyles()
    const [authProfile] = useAtom(profileAtom)
    const [showImitatorModal, setShowImitatorModal] = useState(false)

    if (to === '/mine-noter' && authProfile.isImitator) {
        return (
            <>
                <li className={classes.item}>
                    <NavLink
                        to={to}
                        onClick={(e) => {
                            e.preventDefault()
                            setShowImitatorModal(true)
                        }}
                        className={({ isActive }) =>
                            `${classes.link} ${isActive ? 'active' : 'link'}`
                        }
                    >
                        <div>{label}</div>
                    </NavLink>
                </li>
                <ImitatorNoAccessWarning
                    show={showImitatorModal}
                    onClose={() => setShowImitatorModal(false)}
                />
            </>
        )
    }

    return (
        <li className={classes.item}>
            <NavLink
                to={to}
                className={({ isActive }) =>
                    `${classes.link} ${isActive ? 'active' : 'link'}`
                }
            >
                <div>{label}</div>
            </NavLink>
        </li>
    )
}

const TabbedMenu: FC = ({ children }) => {
    const classes = useStyles()
    const layout = useContainerStyles()

    return (
        <div className={classes.container}>
            <div className={layout.container}>
                <ul className={classes.menu}>{children}</ul>
            </div>
        </div>
    )
}

export { TabbedMenu, TabItem }
